module.exports = __webpack_public_path__ + "static/Preview-25b266ff9fca487838fc30591b8fbcc1.mp4";